import React, { useContext, useEffect, useState } from 'react'

import './styles.css'
import { Deck } from '../../searchEngine/types';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { myDecksStrings } from '../../utils';
import { getAllUserDecks } from '../../services';
import { LoadingContext, LoadingContextType } from '../../contexts';
import { deleteDeck } from '../../services';

const MyDecks = () => {
    const { isLoading, setLoading } = useContext<LoadingContextType>(LoadingContext);
    const [decksToShow, setDecksToShow] = useState<Array<Deck>>([])

    const navigate = useNavigate()

    useEffect(() => {
        setLoading(true)
        getAllUserDecks().then(decks => {
            setLoading(false)
            setDecksToShow(decks)
        })
    }, [])

    const deckClickHandler = (deckId: string) => {
        const params = { deckId };

        if (deckId)
            navigate({
                pathname: '/deckviewer',
                search: `?${createSearchParams(params)}`,
            })
    }

    const deleteButtonHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, deckId: string) => {
        e.stopPropagation()
        setLoading(true)
        setDecksToShow(decksToShow.filter(deck => deck.id !== deckId))
        deleteDeck(deckId).then(() => setLoading(false))
    }

    return (
        <div className='my-decks-wrapper'>
            {
                decksToShow.map((deck, index) => <div key={index} className='deck-data-wrapper' onClick={() => deckClickHandler(deck.id || '')}>
                    <div className='delete-deck-button' onClick={e => deleteButtonHandler(e, deck.id || '')}>x</div>
                    <div className='title-label'>{deck.title}</div>
                    <div className='version-label'>versão: {deck.version}</div>
                </div>)
            }
        </div>
    )
}

export default MyDecks
